<template>
  <v-app>
    <v-app-bar app class="elevation-1">
      <v-toolbar-title class="headline">
        <router-link to="/" class="black--text">
          <span>Roadmap </span>
          <span class="font-weight-light">project</span>
        </router-link>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <router-link class="black--text" to="/vis">
        <v-btn text class="mr-2">Knowledge base</v-btn>
      </router-link>
      <router-link class="black--text" to="/roadmaps">
        <v-btn text class="mr-2">Roadmaps</v-btn>
      </router-link>
      <router-link class="black--text" to="/about">
        <v-btn text class="mr-2">About</v-btn>
      </router-link>
    </v-app-bar>

    <v-content>
      <router-view></router-view>
    </v-content>

    <v-footer
            padless
            class="font-weight-medium"
            :elevation="5"
            :color="'#FFFFFF'"
    >
      <v-col
              class="text-center"
              cols="12"
      >
        {{ new Date().getFullYear() }} — <strong>Roadmap project</strong>
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
  import data from '../data/out';

  export default {
    name: 'App',
    created() {
      this.$store.dispatch('loadData', {data})
    }
  };
</script>

<style scoped>
  a {
    text-decoration: none !important;
  }
</style>
